import { useAuth } from "../context/AuthContext";

/**
 * The brand the current session is operating inside.
 *
 * Use this instead of writing a product name into JSX. Copy like
 * "Push leads into LeadFlow" is wrong for every business except the first one,
 * and a super admin switching brands should see the label change with them.
 *
 * Pre-auth screens (login) have no brand yet — see PLATFORM_NAME below.
 */
export function useBrand() {
  const { user, businesses } = useAuth();
  const current = businesses?.find((b) => b.slug === user?.business);
  return {
    slug: user?.business || "",
    name: current?.name || user?.business_name || PLATFORM_NAME,
    shortName: current?.branding?.short_name || user?.business_name || PLATFORM_NAME,
    productName: current?.branding?.product_name || PLATFORM_NAME,
    color: current?.branding?.primary_color || "",
    logo: current?.branding?.logo_url || "",
  };
}

/**
 * Neutral platform name for screens shown before we know who is logging in.
 *
 * The login page deliberately does NOT brand itself per business: it would have
 * to look the email up first, which tells an attacker which brand any address
 * belongs to. Set REACT_APP_PLATFORM_NAME to rename it.
 */
export const PLATFORM_NAME = process.env.REACT_APP_PLATFORM_NAME || "LeadFlow";
